import { Box, Divider } from '@mui/material';
import { ReactComponent as CheckIcon } from 'core/assets/svg/pricing-page/check.svg';
import { ReactComponent as CrossIcon } from 'core/assets/svg/pricing-page/Cross-Red.svg';
import { ReactComponent as ParallelGenerationIcon } from 'core/assets/svg/pricing-page/parallel-generations-icon.svg';
import BaseTypography from 'core/components/typography/BaseTypography';
import { SubscriptionPlanType } from 'core/constants/enums/SubscriptionPlanType.ts';
import { subscriptionCardStyles } from 'core/layouts/components/subscription-plans/components/subscription-card/SubscriptionCardStyles';
import { ConditionalLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import { thousandSeparator } from 'core/utils/numberUtils';
import React from 'react';

export function SubscriptionCardDetails({ id, plan, planType, generationsDetails, offersDetails }) {
	return (
		<>
			<Box
				id={`${id}-card-offer`}
				sx={[reusableStyles.flexColWithGap(12), subscriptionCardStyles.cardOffer]}
			>
				<Box id={`${id}-card-header`} sx={[subscriptionCardStyles.subscriptionPlanCardHeader]}>
					<Box
						sx={[
							subscriptionCardStyles.subscriptionPlanCardHeader,
							{
								width: 'auto',
								padding: '0',
								alignItems: 'flex-start',
								gap: '6px',
							},
						]}
					>
						<BaseTypography
							id={`${id}-includes-text`}
							key={`${id}-includes-text`}
							variant="tooltip_v2_regular"
							styles={{ color: 'colors.light3' }}
						>
							{planType === SubscriptionPlanType.ONE_TIME
								? 'can be consumed for'
								: `Generations per ${plan.validity} `}
						</BaseTypography>
						<Box
							sx={[reusableStyles.flexColWithGap(4), { width: '100%', alignItems: 'flex-start' }]}
						>
							{generationsDetails.map(
								(featuresData) =>
									(featuresData.value != null || featuresData.value !== undefined) && (
										<Box
											key={`${featuresData.id}-cont`}
											id={`${featuresData.id}-cont`}
											sx={[
												reusableStyles.flexRowWithGap(4),
												{
													'& svg': {
														height: '16px',
														width: '16px',
													},
												},
											]}
										>
											{featuresData?.value === 0 ? (
												<>
													<CrossIcon />
													<BaseTypography
														id={`${id}-credits-text`}
														key={`${id}-credits-text`}
														variant="b2_v2_bold"
														styles={{
															color: 'colors.light5',
														}}
													>
														{' '}
														{thousandSeparator(featuresData.value)} {featuresData.restrictedText}
													</BaseTypography>
												</>
											) : (
												<>
													{featuresData.icon}
													<BaseTypography
														id={`${id}-credits-text`}
														key={`${id}-credits-text`}
														variant="b3_medium"
														styles={{
															color: 'colors.light2',
														}}
													>
														<BaseTypography
															id={`${id}-credits-value`}
															key={`${id}-credits-value`}
															component="span"
															variant="b3_regular"
															styles={{ color: 'colors.light4' }}
														>
															Upto
														</BaseTypography>{' '}
														{thousandSeparator(featuresData.value)} {featuresData.text}
													</BaseTypography>
												</>
											)}
										</Box>
									),
							)}
						</Box>
					</Box>
				</Box>

				<ConditionalLayer isShown={planType !== SubscriptionPlanType.ONE_TIME}>
					<Divider sx={{ borderColor: 'colors.dark1', width: '100%' }} />
					<Box sx={reusableStyles.flexRowWithGap(6)}>
						<ParallelGenerationIcon />
						<BaseTypography
							id={`${id}-parallel-generations-text-01`}
							key={`${id}-parallel-generations-text-01`}
							variant="b3_medium"
							color="colors.light3"
						>
							{plan?.features?.parallelGeneration?.restrictions?.total} Simultaneous generations
						</BaseTypography>
					</Box>
					<Divider sx={{ borderColor: 'colors.dark1' }} />
					<Box sx={[subscriptionCardStyles.subscriptionPlanCardOffersSection]}>
						{offersDetails.map(
							(offer) =>
								offer.allowed != null && (
									<Box key={offer.title} sx={[subscriptionCardStyles.subscriptionPlanCardOffer]}>
										{offer.allowed ? <CheckIcon /> : <CrossIcon />}
										<BaseTypography
											id={`${id}-${offer.title}-text`}
											key={`${id}-${offer.title}-text`}
											variant="b3_medium"
											styles={{
												color: offer.allowed ? 'colors.light3' : 'colors.palePink',
											}}
										>
											{offer.title}
										</BaseTypography>
									</Box>
								),
						)}
					</Box>
				</ConditionalLayer>
			</Box>
			{planType === SubscriptionPlanType.ONE_TIME && (
				<Box
					sx={[
						reusableStyles.flexRow,
						{
							justifySelf: 'flex-end',
							width: '100%',
							maxWidth: '250px',
							justifyContent: 'center',
							flex: 1,
						},
					]}
				>
					<BaseTypography
						variant="b3_regular"
						sx={{ color: 'colors.light4', alignSelf: 'flex-end', textAlign: 'center' }}
					>
						These credits don’t expire and can be used only with an active subscription.
					</BaseTypography>
				</Box>
			)}
		</>
	);
}
